import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

import UploadScreen from "@/components/UploadScreen";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDate(value) {
  if (!value) return "date inconnue";
  return new Date(value).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export default function InterviewPanel({ sessionId, steps, onUploaded }) {
  const [replacing, setReplacing] = useState(false);
  const interview = steps?.interview;

  const handleUpload = async (files, pastedText, metadata) => {
    const formData = new FormData();
    if (sessionId !== "nouveau") {
      formData.append("session_id", sessionId);
    }
    formData.append("pasted_text", pastedText || "");
    files.forEach((file) => formData.append("files", file));

    try {
      const uploadRes = await axios.post(`${API}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (!uploadRes.data.success) {
        toast.error(uploadRes.data.error || "Erreur lors du téléversement");
        return;
      }

      const activeSessionId = uploadRes.data.session_id
        || (sessionId !== "nouveau" ? sessionId : null);
      toast.success(uploadRes.data.message);

      const genFormData = new FormData();
      genFormData.append("session_id", activeSessionId);
      genFormData.append("prenom_nom", metadata.prenomNom || "[Prénom Nom]");
      genFormData.append("activite", metadata.activite || "[Activité professionnelle]");
      genFormData.append("public_cible", metadata.publicCible || "[Public cible]");
      genFormData.append("instructions_supp", metadata.instructionsSupp || "");

      const genRes = await axios.post(`${API}/generate`, genFormData);
      if (genRes.data.success) {
        onUploaded(activeSessionId);
      } else {
        toast.error(genRes.data.error || "Erreur lors du démarrage");
      }
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors du téléversement");
    }
  };

  if (interview?.state !== "deposee") {
    return <UploadScreen onGenerate={handleUpload} />;
  }

  if (replacing) {
    return (
      <div>
        <div className="mx-auto flex max-w-5xl justify-end px-6 pt-4">
          <Button variant="outline" onClick={() => setReplacing(false)}>Annuler</Button>
        </div>
        <UploadScreen onGenerate={handleUpload} />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-xl space-y-4 p-8">
      <p>Transcription déposée le {formatDate(interview.since)}</p>
      <Button variant="outline" onClick={() => setReplacing(true)}>
        Remplacer
      </Button>
    </div>
  );
}
